export enum FORM_VALIDITY_ACTION_TYPES {
  SET_FORM_VALIDITY_TRUE = 'errors/SET_FORM_VALIDITY_TRUE',
  SET_FORM_VALIDITY_FALSE = 'errors/SET_FORM_VALIDITY_FALSE',
}

export enum ERROR_MESSAGE_ACTION_TYPES {
  SET_ERROR_MESSAGE = 'errors/SET_ERROR_MESSAGE',
  REMOVE_ERROR_MESSAGE = 'errors/REMOVE_ERROR_MESSAGE',
}

export enum GENERIC_SERVER_ERROR_ACTION_TYPES {
  SET_GENERIC_SERVER_ERROR_TRUE = 'errors/SET_GENERIC_SERVER_ERROR_TRUE',
  SET_GENERIC_SERVER_ERROR_FALSE = 'errors/SET_GENERIC_SERVER_ERROR_FALSE',
}

export enum POPUP_SERVER_ERROR_MESSAGE_ACTION_TYPES {
  SET_POPUP_SERVER_ERROR_MESSAGE = 'errors/SET_POPUP_SERVER_ERROR_MESSAGE',
}
